import React, { useState, useEffect } from 'react';
import { debounce } from 'lodash';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { StyledInputLabel, StyledSearchFieldComponent } from './SearchField.styles';

interface Props {
  value?: string;
  setValue: (value: string) => void;
  fetchConsortia: (resetSearch?: boolean, setFetchState?: boolean) => void;
}

const allowedCharsRegExp = /^[a-zA-Z0-9 /-]*$/;

const SearchField: React.FC<Props> = ({ fetchConsortia, value = '', setValue }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { fetchingConsortia } = useSelector((state: RootState) => state.consortiaManagement);

  useEffect(() => {
    if (!fetchingConsortia) {
      setIsLoading(false);
    }
  }, [fetchingConsortia]);

  const debounceSearch = debounce((): void => {
    setIsLoading(true);
    fetchConsortia(true, false);
  }, 500);

  const clearValue = () => {
    setValue('');
    debounceSearch();
  };

  const onValueChange = (newValue: string): void => {
    setValue(newValue);
    debounceSearch();
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    if (allowedCharsRegExp.test(event.target.value)) {
      onValueChange(event.target.value);
    }
  };

  return (
    <div>
      <StyledInputLabel htmlFor='searchField'>Search for a consortium</StyledInputLabel>
      <StyledSearchFieldComponent
        value={value}
        placeholder='Search'
        isLoading={isLoading && fetchingConsortia}
        onClearValue={clearValue}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchField;
